import { enableProdMode, importProvidersFrom, provideExperimentalZonelessChangeDetection } from "@angular/core";

import { environment } from "./environments/environment";
import { provideRouter, RouterModule, withInMemoryScrolling } from "@angular/router";
import { appRoutes } from "./app/app.routes";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { StoreModule } from "@ngrx/store";
import { featureName, navReducer } from "./app/store/nav/nav.reducer";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { NgOptimizedImage } from "@angular/common";
import { AppComponent } from "./app/app.component";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      RouterModule,
      StoreModule.forRoot({ [featureName]: navReducer }),
      !environment.production ? StoreDevtoolsModule.instrument() : [],
      NgOptimizedImage,
    ),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
        anchorScrolling: "enabled",
      }),
    ),
    provideExperimentalZonelessChangeDetection(),
  ],
}).catch((err) => console.error(err));
